<template>
  <div class="browse-records">
    <!-- <Header title="浏览记录" background="white" /> -->
    <!-- <simple-scroll-list v-model="loading" :finished="finished" @load="onLoad"> -->
	<van-list
	  v-model="loading"
	  :finished="finished"
	  finished-text="没有更多了"
	  @load="onLoad"
	  class="simple-scroll-list"
	>
      <div class="list-item" v-for="item in list" :key="item.id" v-if="item.goods" @click="$router.push('/classify/commodity/details/'+item.goodsId)">
        <img :src="item.goods.thumb" alt="" />
        <p class="title">{{ item.goods.title }}</p>
        <div class="flex-between">
          <p class="time">{{ item.createdAt }}</p>
          <img
            src="../../assets/img/car/del@2x.png"
            alt=""
            class="icon"
            @click.stop="del(item.goodsId)"
          />
        </div>
      </div>
	  </van-list>
    <!-- </simple-scroll-list> -->
  </div>
</template>

<script type="text/ecmascript-6">
import SimpleScrollList from "../../components/SimpleScrollList.vue";
export default {
  data() {
    return {
      list: [],
      form: {
        lastId: 0,
        page: 1,
      },
      finished: false,
      loading: false,
    };
  },
  methods: {
    onLoad() {
      this.$post({
        url: "/portal/Shop",
        module: "Goods",
        interface: "2200",
        data: this.form,
      }).then((res) => {
        console.log("记录", res);
        this.list = this.list.concat(res.list);
        this.form.lastId = res.lastId;
        this.form.page++;
        if (res.currentPage == res.lastPage) {
          this.finished = true;
        }
        this.loading = false;
      });
    },
    del(id) {
      this.$dialog
        .confirm({
          title: "删除",
          message: "确定要删除此记录吗？",
          cancelButtonText: "取消",
          confirmButtonText: "删除",
          cancelButtonColor: "#1677FF",
          confirmButtonColor: "#1677FF",
          className: "confirm-dialog",
        })
        .then(() => {
          this.$toast("删除记录" + id);
          this.$post({
            url: "/portal/Shop",
            module: "Goods",
            interface: "2201",
            data: {
              id,
            },
          }).then(() => {
            this.$toast("删除成功");
            this.$func.sleep().then(this.refresh);
          });
        })
        .catch(() => {});
    },
    refresh() {
      this.list = [];
      this.loading = true;
      this.finished = false;
      this.form.page = 1;
      this.form.lastId = 0;
      this.onLoad();
    },
  },
  components: { SimpleScrollList },
};
</script>

<style scoped lang="less">
.browse-records {
  height: 100vh;
  background-color: #fbfbfb;
  display: flex;
  flex-direction: column;
  font-family: PingFangSC-Medium, PingFang SC;

  .icon {
    width: 22px;
    height: 22px;
  }

  .simple-scroll-list {
    padding: 14px 16px;
    flex: 1;
	display: flex;
	flex-wrap: wrap;
    /deep/.list-inner {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
    }

    .list-item {
      margin-bottom: 16px;
	  width:50%;
      & > img {
        width: 164px;
        height: 164px;
        margin-bottom: 7px;
      }

      .title {
        font-size: 14px;
        font-weight: 600;
        color: #333333;
      }

      .time {
        font-size: 12px;
        color: #919398;
      }
    }
  }
}
</style>